
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Babel Macro | v4`}</h2>
    <p><a parentName="p" {...{
        "href": "https://babeljs.io/blog/2017/09/11/zero-config-with-babel-macros"
      }}>{`Babel macros`}</a>{` are quickly gaining steam as a full-featured option to allow advanced code transpilation for zero-config projects like `}<a parentName="p" {...{
        "href": "https://github.com/facebook/create-react-app"
      }}>{`create-react-app`}</a>{`.`}</p>
    <p>{`If your scaffold is set up with `}<a parentName="p" {...{
        "href": "https://github.com/kentcdodds/babel-plugin-macros"
      }}><inlineCode parentName="a">{`babel-plugin-macros`}</inlineCode></a>{`, then simply use the new `}<inlineCode parentName="p">{`styled-components/macro`}</inlineCode>{` import instead of `}<inlineCode parentName="p">{`styled-components`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import styled, { createGlobalStyle } from 'styled-components/macro'

const Thing = styled.div\`
  color: red;
\`

const GlobalStyle = createGlobalStyle\`
  body {
    color: 'white';
  }
\`
`}</code></pre>
    <p>{`The macro incorporates all the functionality of `}<a parentName="p" {...{
        "href": "/docs/tooling#babel-plugin"
      }}>{`our babel plugin`}</a>{` while allowing the unejected tooling to handle the Babel part of the build process. Special thanks to `}<a parentName="p" {...{
        "href": "https://github.com/lucleray"
      }}>{`Luc Leray (@lucleray)`}</a>{` for making this happen!`}</p>
    <h3>{`EXPERIMENTAL Config`}</h3>
    <p><a parentName="p" {...{
        "href": "https://github.com/kentcdodds/babel-plugin-macros"
      }}><inlineCode parentName="a">{`babel-plugin-macros`}</inlineCode></a>{` uses `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/cosmiconfig"
      }}><inlineCode parentName="a">{`cosmiconfig`}</inlineCode></a>{` to read a `}<inlineCode parentName="p">{`babel-plugin-macros`}</inlineCode>{` configuration which
can be located in any of the following files up the directories from the
importing file:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`.babel-plugin-macrosrc`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.babel-plugin-macrosrc.json`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.babel-plugin-macrosrc.yaml`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.babel-plugin-macrosrc.yml`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.babel-plugin-macrosrc.js`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`babel-plugin-macros.config.js`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`babelMacros`}</inlineCode>{` in `}<inlineCode parentName="li">{`package.json`}</inlineCode></li>
    </ul>
    <p>{`You can then specify the same options as `}<a parentName="p" {...{
        "href": "/docs/tooling#babel-plugin"
      }}>{`our babel plugin`}</a>{` in `}<inlineCode parentName="p">{`styledComponents`}</inlineCode>{` entry:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// babel-plugin-macros.config.js
module.exports = {
  // ...
  // Other macros config
  styledComponents: {
    pure: true,
  },
}
`}</code></pre>
    <p>{`For more information, see `}<a parentName="p" {...{
        "href": "https://github.com/kentcdodds/babel-plugin-macros/blob/master/other/docs/author.md#config-experimental"
      }}>{`EXPERIMENTAL config for babel-plugin-macros `}</a>{`.`}</p>
    <h3>{`Enforce macro imports`}</h3>
    <p>{`You may want to ensure that objects are consistently imported from the macro across your project. This can be achieved by using a `}<a parentName="p" {...{
        "href": "https://eslint.org/docs/rules/no-restricted-imports"
      }}><inlineCode parentName="a">{`no-restricted-imports`}</inlineCode></a>{` rule from ESLint:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`"no-restricted-imports": [
  "error",
  {
    "paths": [{
      "name": "styled-components",
      "message": "Please import from styled-components/macro."
    }],
    "patterns": [
      "!styled-components/macro"
    ]
  }
]
`}</code></pre>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;